module.exports = __webpack_public_path__ + "img/bio.16f088b0.jpg";